
(function() {
  const lightbox = () => {
    const leftArrowSVGString = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon icon--direction-aware" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square" stroke-width="2"></path></svg>';
    const closeSvgString = '<svg aria-hidden="true" focusable="false" fill="none" width="16" class="icon" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.2"></path></svg>';
    const lightbox = new PhotoSwipeLightbox({
      gallery: '.splide__gallery',
      children: '.splide__slide:has(.product-media-zoom)',
      bgOpacity: 1,
      showHideAnimationType: 'zoom',
      loop: true,
      counter: false,
      zoom: true,
      bgClickAction: 'close',
      tapAction: 'zoom',
      doubleTapAction: 'zoom',
      imageClickAction: 'zoom',
      arrowPrevSVG: leftArrowSVGString,
      arrowNextSVG: leftArrowSVGString,
      closeSVG: closeSvgString,
      pswpModule: PhotoSwipe,
      maxZoomLevel: 3,
      initialZoomLevel: 'fit',
      secondaryZoomLevel: 2,
      mouseMovePan: true
    });
    lightbox.on('uiRegister', function() {
      lightbox.pswp.ui.registerElement({
        name: 'custom-alt-text',
        order: 9,
        isButton: false,
        html: 'Alt Text',
        appendTo: 'root',
        onInit: (el, pswp) => {
          lightbox.pswp.on('change', () => {
            const currSlideElement = lightbox.pswp.currSlide.data.element;
            let altTextHTML = '';

            if (currSlideElement) {
              const altTextElement = currSlideElement.querySelector('.splide__slide--alt-text');

              if (altTextElement) {
                altTextHTML = altTextElement.innerHTML;
              } else {
                altTextHTML = currSlideElement.querySelector('img').getAttribute('alt');
              }
            }

            el.innerHTML = altTextHTML || '';
          });
        }
      });
    });
    lightbox.init();
  }
  document.addEventListener("DOMContentLoaded", function() {
    lightbox();
    document.addEventListener('shopify:section:load', () => lightbox());
  });
})()

